import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  rolesResponse: any = {};
  onRolesResponseChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient) {}

  createRole(payload: any) {
    return this.http.post(`${environment.apiUrl}/roles/create`, payload);
  }

  updateRole(payload: any) {
    return this.http.put(`${environment.apiUrl}/roles/update`, payload);
  }

  deleteRole(id: any) {
    return this.http.delete(`${environment.apiUrl}/roles/delete/${id}`);
  }

  getOneRoleById(id: any) {
    return this.http.get(`${environment.apiUrl}/roles/get-one/${id}`);
  }

  getPagedRoles(payload: any) {
    return this.http.post(`${environment.apiUrl}/roles/get-paged`, payload);
  }

  getPermissionsByGroup() {
    return this.http.get(`${environment.apiUrl}/permission/get-by-group`);
  }

  getRolesForOptions() {
    return this.http.get(`${environment.apiUrl}/roles/get`);
  }
}
